import React, { useEffect, useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Building, Crown, Users, GraduationCap, Calendar, Settings, Edit, Save, X, Key, Bell, LogOut, ChevronRight, CreditCard, FileText, TrendingUp, CheckCircle, School, BookOpen, BarChart2 } from 'lucide-react';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
interface PasswordChangeModalProps {
  onClose: () => void;
  onSuccess: () => void;
}
interface EmailUpdateModalProps {
  onClose: () => void;
  onSuccess: (email: string) => void;
  currentEmail: string;
}
interface LogoutConfirmModalProps {
  onClose: () => void;
  onConfirm: () => void;
}
// Password Change Modal Component
const PasswordChangeModal: React.FC<PasswordChangeModalProps> = ({
  onClose,
  onSuccess
}) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (newPassword.length < 8) {
      setError('Şifre en az 8 karakter uzunluğunda olmalıdır.');
      return;
    }
    if (!/[A-Z]/.test(newPassword)) {
      setError('Şifre en az bir büyük harf içermelidir.');
      return;
    }
    if (!/\d/.test(newPassword)) {
      setError('Şifre en az bir rakam içermelidir.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Girdiğiniz yeni şifreler eşleşmiyor.');
      return;
    }
    setTimeout(() => {
      onSuccess();
      onClose();
    }, 1000);
  };
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1643">
      <AuroraFloatingCard className="w-full max-w-md" data-id="element-1644">
        <div className="p-6" data-id="element-1645">
          <div className="flex justify-between items-center mb-6" data-id="element-1646">
            <h2 className="text-xl font-bold text-white" data-id="element-1647">Şifre Değiştir</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1648">
              <X className="w-6 h-6" data-id="element-1649" />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1650">
            <div className="space-y-2" data-id="element-1651">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1652">
                Mevcut Şifre
              </label>
              <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2.5 focus:ring-2 ring-purple-500/20" required data-id="element-1653" />
            </div>
            <div className="space-y-2" data-id="element-1654">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1655">
                Yeni Şifre
              </label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2.5 focus:ring-2 ring-purple-500/20" required data-id="element-1656" />
              <p className="text-xs text-gray-400" data-id="element-1657">
                En az 8 karakter, bir büyük harf ve bir rakam içermelidir
              </p>
            </div>
            <div className="space-y-2" data-id="element-1658">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1659">
                Yeni Şifre (Tekrar)
              </label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2.5 focus:ring-2 ring-purple-500/20" required data-id="element-1660" />
            </div>
            {error && <p className="text-sm text-red-500" data-id="element-1661">{error}</p>}
            <div className="pt-4 flex justify-end gap-3" data-id="element-1662">
              <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors text-white" data-id="element-1663">
                İptal
              </button>
              <button type="submit" className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg hover:opacity-90 transition-opacity text-white" data-id="element-1664">
                Kaydet
              </button>
            </div>
          </form>
        </div>
      </AuroraFloatingCard>
    </div>;
};
// Email Update Modal Component
const EmailUpdateModal: React.FC<EmailUpdateModalProps> = ({
  onClose,
  onSuccess,
  currentEmail
}) => {
  const [newEmail, setNewEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!/\S+@\S+\.\S+/.test(newEmail)) {
      setError('Geçerli bir e-posta adresi giriniz.');
      return;
    }
    if (newEmail === currentEmail) {
      setError('Yeni e-posta adresi mevcut adresinizle aynı olamaz.');
      return;
    }
    setTimeout(() => {
      onSuccess(newEmail);
      onClose();
    }, 1000);
  };
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1665">
      <AuroraFloatingCard className="w-full max-w-md" data-id="element-1666">
        <div className="p-6" data-id="element-1667">
          <div className="flex justify-between items-center mb-6" data-id="element-1668">
            <h2 className="text-xl font-bold text-white" data-id="element-1669">E-posta Güncelle</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1670">
              <X className="w-6 h-6" data-id="element-1671" />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1672">
            <div className="space-y-2" data-id="element-1673">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1674">
                Mevcut E-posta
              </label>
              <input type="email" value={currentEmail} disabled className="w-full bg-gray-800/30 text-gray-400 rounded-lg px-4 py-2.5 border border-purple-500/20" data-id="element-1675" />
            </div>
            <div className="space-y-2" data-id="element-1676">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1677">
                Yeni E-posta Adresi
              </label>
              <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2.5 focus:ring-2 ring-purple-500/20" required data-id="element-1678" />
            </div>
            <div className="space-y-2" data-id="element-1679">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1680">
                Mevcut Şifre
              </label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2.5 focus:ring-2 ring-purple-500/20" required data-id="element-1681" />
            </div>
            {error && <p className="text-sm text-red-500" data-id="element-1682">{error}</p>}
            <div className="pt-4 flex justify-end gap-3" data-id="element-1683">
              <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors text-white" data-id="element-1684">
                İptal
              </button>
              <button type="submit" className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg hover:opacity-90 transition-opacity text-white" data-id="element-1685">
                Güncelle
              </button>
            </div>
          </form>
        </div>
      </AuroraFloatingCard>
    </div>;
};
// Logout Confirm Modal Component
const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  onClose,
  onConfirm
}) => {
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1686">
      <AuroraFloatingCard className="w-full max-w-md" data-id="element-1687">
        <div className="p-6" data-id="element-1688">
          <div className="flex justify-between items-center mb-6" data-id="element-1689">
            <h2 className="text-xl font-bold text-white" data-id="element-1690">Çıkış Yap</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1691">
              <X className="w-6 h-6" data-id="element-1692" />
            </button>
          </div>
          <div className="space-y-4" data-id="element-1693">
            <p className="text-gray-300" data-id="element-1694">
              Çıkış yapmak istediğinizden emin misiniz?
            </p>
            <div className="flex justify-end gap-3" data-id="element-1695">
              <button onClick={onClose} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors text-white" data-id="element-1696">
                İptal
              </button>
              <button onClick={onConfirm} className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg transition-colors text-white" data-id="element-1697">
                Çıkış Yap
              </button>
            </div>
          </div>
        </div>
      </AuroraFloatingCard>
    </div>;
};
// Main Profile Component
export function YoneticiProfil() {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  // Modal states
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [profileData, setProfileData] = useState({
    name: 'Mehmet Yılmaz',
    email: 'mehmet.yilmaz@kurumegitim.com',
    role: 'Kurum Sahibi',
    organization: 'ABC Eğitim Kurumları',
    phone: '+90 555 123 4567',
    address: 'Ankara, Türkiye'
  });
  // Subscription data
  const subscriptionData = {
    package: 'LGS Kurumsal Paket',
    license: '350 Öğrenci Lisansı',
    validUntil: '2025-09-01',
    status: 'Aktif'
  };
  // Statistics - ANASAYFADAKI VERILERLE AYNI
  // Bu veriler YoneticiDashboard.tsx'teki stats ile aynı olmalı
  const stats = [{
    title: 'Toplam Öğrenci',
    value: '350',
    icon: Users,
    description: 'Kayıtlı öğrenci sayısı',
    change: '+5.3%',
    increasing: true,
    suffix: 'öğrenci'
  }, {
    title: 'Toplam Öğretmen',
    value: '8',
    icon: GraduationCap,
    description: 'Aktif öğretmen sayısı',
    change: '+2.2%',
    increasing: true,
    suffix: 'öğretmen'
  }, {
    title: 'Toplam Sınıf',
    value: '14',
    icon: BookOpen,
    description: 'Oluşturulan sınıf sayısı',
    change: '0%',
    increasing: null,
    suffix: 'sınıf'
  }, {
    title: 'Kurum Net Ortalaması',
    value: '68.5',
    icon: BarChart2,
    description: 'Öğrencilerin ortalama net sayısı',
    change: '-1.4%',
    increasing: false,
    suffix: 'net'
  }];
  const handlePasswordChangeSuccess = () => {
    alert('Şifreniz başarıyla güncellendi');
  };
  const handleEmailUpdateSuccess = (newEmail: string) => {
    setProfileData({
      ...profileData,
      email: newEmail
    });
    alert('E-posta adresiniz başarıyla güncellendi');
  };
  const handleLogout = () => {
    navigate('/');
  };
  return <div className="space-y-8 p-6" data-id="element-1698">
      <h1 className="text-3xl font-bold text-white" data-id="element-1699">Profil</h1>
      {/* Profile Header */}
      <AuroraFloatingCard data-id="element-1700">
        <div className="p-6" data-id="element-1701">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-1702">
            <div className="relative" data-id="element-1703">
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=160&h=160&fit=crop&crop=faces" alt="Profile" className="w-24 h-24 rounded-full border-2 border-purple-500/50" data-id="element-1704" />
              <button className="absolute -bottom-1 -right-1 p-1.5 rounded-full bg-purple-600 text-white hover:bg-purple-700 transition-colors" data-id="element-1705">
                <Edit className="w-4 h-4" data-id="element-1706" />
              </button>
            </div>
            <div className="flex-1 min-w-0" data-id="element-1707">
              {isEditing ? <div className="space-y-4" data-id="element-1708">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1709">
                    <div className="space-y-2" data-id="element-1710">
                      <label className="text-sm text-gray-400" data-id="element-1711">
                        İsim Soyisim
                      </label>
                      <input type="text" value={profileData.name} onChange={e => setProfileData({
                    ...profileData,
                    name: e.target.value
                  })} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2" data-id="element-1712" />
                    </div>
                    <div className="space-y-2" data-id="element-1713">
                      <label className="text-sm text-gray-400" data-id="element-1714">Telefon</label>
                      <input type="text" value={profileData.phone} onChange={e => setProfileData({
                    ...profileData,
                    phone: e.target.value
                  })} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2" data-id="element-1715" />
                    </div>
                    <div className="space-y-2 sm:col-span-2" data-id="element-1716">
                      <label className="text-sm text-gray-400" data-id="element-1717">Adres</label>
                      <input type="text" value={profileData.address} onChange={e => setProfileData({
                    ...profileData,
                    address: e.target.value
                  })} className="w-full bg-gray-800/50 border border-purple-500/30 text-white rounded-lg px-4 py-2" data-id="element-1718" />
                    </div>
                  </div>
                  <div className="flex justify-end gap-3" data-id="element-1719">
                    <button onClick={() => setIsEditing(false)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors text-white" data-id="element-1720">
                      <X className="w-4 h-4" data-id="element-1721" />
                      İptal
                    </button>
                    <button onClick={() => {
                  setIsEditing(false);
                  alert('Profil bilgileriniz güncellendi');
                }} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 hover:opacity-90 transition-opacity text-white" data-id="element-1722">
                      <Save className="w-4 h-4" data-id="element-1723" />
                      Kaydet
                    </button>
                  </div>
                </div> : <div className="space-y-4" data-id="element-1724">
                  <div className="flex items-center justify-between" data-id="element-1725">
                    <div data-id="element-1726">
                      <h2 className="text-2xl font-bold text-white" data-id="element-1727">
                        {profileData.name}
                      </h2>
                      <div className="flex items-center gap-2 mt-1" data-id="element-1728">
                        <Crown className="w-4 h-4 text-yellow-500" data-id="element-1729" />
                        <span className="text-yellow-500 font-medium" data-id="element-1730">
                          {profileData.role}
                        </span>
                      </div>
                    </div>
                    <button onClick={() => setIsEditing(true)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-800/50 hover:bg-gray-700/50 transition-colors text-white" data-id="element-1731">
                      <Edit className="w-4 h-4" data-id="element-1732" />
                      Düzenle
                    </button>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6" data-id="element-1733">
                    <div className="flex items-center gap-3 text-gray-300" data-id="element-1734">
                      <Mail className="w-5 h-5 text-purple-400" data-id="element-1735" />
                      <span data-id="element-1736">{profileData.email}</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-300" data-id="element-1737">
                      <Building className="w-5 h-5 text-purple-400" data-id="element-1738" />
                      <span data-id="element-1739">{profileData.organization}</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-300" data-id="element-1740">
                      <User className="w-5 h-5 text-purple-400" data-id="element-1741" />
                      <span data-id="element-1742">{profileData.phone}</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-300" data-id="element-1743">
                      <Mail className="w-5 h-5 text-purple-400" data-id="element-1744" />
                      <span data-id="element-1745">{profileData.address}</span>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </AuroraFloatingCard>
      {/* Statistics - Anasayfadaki ile aynı */}
      <div data-id="element-1746">
        <h2 className="text-xl font-bold text-white mb-4" data-id="element-1747">İstatistikler</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1748">
          {stats.map(stat => <AuroraFloatingCard key={stat.title} className="h-full" data-id="element-1749">
              <div className="p-5 flex flex-col justify-between h-full" data-id="element-1750">
                <div data-id="element-1751">
                  <div className="flex items-center justify-between mb-3" data-id="element-1752">
                    <h3 className="text-sm font-medium text-gray-400" data-id="element-1753">
                      {stat.title}
                    </h3>
                    <stat.icon className="w-5 h-5 text-gray-400" data-id="element-1754" />
                  </div>
                  <div className="flex items-baseline gap-1" data-id="element-1755">
                    <p className="text-3xl font-bold text-white" data-id="element-1756">
                      {stat.value}
                    </p>
                    {stat.suffix && <span className="text-sm text-gray-400 font-normal" data-id="element-1757">
                        {stat.suffix}
                      </span>}
                  </div>
                </div>
                <div className="flex items-center justify-between" data-id="element-1758">
                  <p className="text-xs text-gray-500" data-id="element-1759">{stat.description}</p>
                  {stat.change && <span className={`text-xs font-medium ${stat.increasing === true ? 'text-green-400' : stat.increasing === false ? 'text-red-400' : 'text-gray-400'}`} data-id="element-1760">
                      {stat.change}
                    </span>}
                </div>
              </div>
            </AuroraFloatingCard>)}
        </div>
      </div>
      {/* Subscription Info */}
      <div data-id="element-1761">
        <h2 className="text-xl font-bold text-white mb-4" data-id="element-1762">
          Abonelik Bilgileri
        </h2>
        <AuroraFloatingCard data-id="element-1763">
          <div className="p-6" data-id="element-1764">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1765">
              <div className="space-y-4" data-id="element-1766">
                <div className="flex items-start gap-3" data-id="element-1767">
                  <CreditCard className="w-5 h-5 text-purple-400 mt-1" data-id="element-1768" />
                  <div data-id="element-1769">
                    <p className="text-sm text-gray-400" data-id="element-1770">Mevcut Paket</p>
                    <p className="text-lg font-semibold text-white" data-id="element-1771">
                      {subscriptionData.package}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-1772">
                  <Users className="w-5 h-5 text-purple-400 mt-1" data-id="element-1773" />
                  <div data-id="element-1774">
                    <p className="text-sm text-gray-400" data-id="element-1775">Lisans Bilgisi</p>
                    <p className="text-lg font-semibold text-white" data-id="element-1776">
                      {subscriptionData.license}
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1777">
                <div className="flex items-start gap-3" data-id="element-1778">
                  <Calendar className="w-5 h-5 text-purple-400 mt-1" data-id="element-1779" />
                  <div data-id="element-1780">
                    <p className="text-sm text-gray-400" data-id="element-1781">Geçerlilik Tarihi</p>
                    <p className="text-lg font-semibold text-white" data-id="element-1782">
                      {new Date(subscriptionData.validUntil).toLocaleDateString('tr-TR')}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-1783">
                  <CheckCircle className="w-5 h-5 text-green-400 mt-1" data-id="element-1784" />
                  <div data-id="element-1785">
                    <p className="text-sm text-gray-400" data-id="element-1786">Durum</p>
                    <p className="text-lg font-semibold text-green-400" data-id="element-1787">
                      {subscriptionData.status}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-700/50" data-id="element-1788">
              <button onClick={() => navigate('/fatura-gecmisi')} className="flex items-center gap-2 text-purple-400 hover:text-purple-300 transition-colors" data-id="element-1789">
                <FileText className="w-5 h-5" data-id="element-1790" />
                <span data-id="element-1791">Fatura Geçmişini Görüntüle</span>
                <ChevronRight className="w-4 h-4" data-id="element-1792" />
              </button>
            </div>
          </div>
        </AuroraFloatingCard>
      </div>
      {/* Account Settings - Sadece Güvenlik */}
      <div data-id="element-1793">
        <h2 className="text-xl font-bold text-white mb-4" data-id="element-1794">Hesap Ayarları</h2>
        <AuroraFloatingCard data-id="element-1795">
          <div className="p-6" data-id="element-1796">
            <div className="space-y-4" data-id="element-1797">
              <h3 className="text-lg font-medium text-white mb-4" data-id="element-1798">Güvenlik</h3>
              <button onClick={() => setShowPasswordModal(true)} className="w-full flex items-center justify-between p-3 bg-gray-800/30 hover:bg-gray-700/30 rounded-lg transition-colors text-white" data-id="element-1799">
                <div className="flex items-center gap-3" data-id="element-1800">
                  <Key className="w-5 h-5 text-gray-400" data-id="element-1801" />
                  <span data-id="element-1802">Şifre Değiştir</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500" data-id="element-1803" />
              </button>
              <button onClick={() => setShowEmailModal(true)} className="w-full flex items-center justify-between p-3 bg-gray-800/30 hover:bg-gray-700/30 rounded-lg transition-colors text-white" data-id="element-1804">
                <div className="flex items-center gap-3" data-id="element-1805">
                  <Mail className="w-5 h-5 text-gray-400" data-id="element-1806" />
                  <span data-id="element-1807">E-posta Güncelle</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500" data-id="element-1808" />
              </button>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-700/50" data-id="element-1809">
              <button onClick={() => setShowLogoutModal(true)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-800/30 hover:bg-gray-700/30 transition-colors text-red-400" data-id="element-1810">
                <LogOut className="w-4 h-4" data-id="element-1811" />
                Çıkış Yap
              </button>
            </div>
          </div>
        </AuroraFloatingCard>
      </div>
      {/* Modals */}
      {showPasswordModal && <PasswordChangeModal onClose={() => setShowPasswordModal(false)} onSuccess={handlePasswordChangeSuccess} data-id="element-1812" />}
      {showEmailModal && <EmailUpdateModal onClose={() => setShowEmailModal(false)} onSuccess={handleEmailUpdateSuccess} currentEmail={profileData.email} data-id="element-1813" />}
      {showLogoutModal && <LogoutConfirmModal onClose={() => setShowLogoutModal(false)} onConfirm={handleLogout} data-id="element-1814" />}
    </div>;
}